/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-09-03 11:47:17
 * @LastEditTime: 2024-11-07 15:50:29
 */
let secondCross = ''; // 本地调试如有跨域问题则赋值，若上线则把cross置空，并改http.js里的域名 /secondApi
const normalOrderAPI = {
  // 我的运输单
  myOrderList: {
    method: 'post',
    url: '/logistics/transportOrder/driver/myOrderList',
    mask: true // 判断是否需要加载loading框
  },
  // 司机端-完成装货
  driverFinishLoading: {
    method: 'post',
    url: '/logistics/transportOrder/driver/finishLoading',
  },
  // 司机端-查询装货和送达信息
  driverLoadingAndDeliveryTime: {
    method: 'get',
    url: '/logistics/transportOrder/driver/loadingAndDeliveryTime',
  },
  // 司机端-货物送达（完成卸货时更新送达时间）
  driverDelivery: {
    method: 'post',
    url: '/logistics/transportOrder/driver/delivery',
  },
  // 修改运输单状态（仅修改运输单的状态）
  updateOrderStatus: {
    method: 'post',
    url: '/logistics/transportOrder/driver/updateTransportOrderStatus',
  },
  // 司机端-当前运输单-全部运输单-运输记录
  recordsQuery: {
    method: 'get',
    url: '/logistics/transportOrder/driver/process/records/query',
  },
  // 更新运输记录
  recordsUpdate: {
    method: 'post',
    url: '/logistics/transportOrder/driver/process/records/update',
  },
  // 签收人 异常上报算签收
  abnormalUpload: {
    method: 'post',
    url: '/logistics/transportOrder/driver/process/records/abnormalUpload',
    mask: false // 判断是否需要加载loading框
  },
  // 运输单基础信息
  driverBaseInfo: {
    method: 'get',
    url: '/logistics/transportOrder/driver/baseInfo',
  },
  // 查询司机在途单
  selDoingOrd: {
    method: 'get',
    url: '/logistics/transportOrder/driver/selDoingOrd'
  },
  // 查看运输过程信息
  driverProcess: {
    method: 'get',
    url: '/logistics/transportOrder/driver/process/query'
  },
  // 更新运输过程信息
  driverProcessUpdate: {
    method: 'post',
    url: '/logistics/transportOrder/driver/process/update'
  },
  // 查看路程
  driverProcessMileageandfeeQuery: {
    method: 'get',
    url: '/logistics/transportOrder/driver/process/mileageandfee/query'
  },
  // 暂存路程/运费
  driverProcessMileageandfeeTempStorage: {
    method: 'post',
    url: '/logistics/transportOrder/driver/process/mileageandfee/tempStorage'
  },
  // 修改路程/运费（提交）
  driverProcessMileageandfeeCommit: {
    method: 'post',
    url: '/logistics/transportOrder/driver/process/mileageandfee/commit'
  },
  // 校验起点时间
  checkNodeTime: {
    method: 'get',
    url: '/logistics/transportOrder/checkNodeTime'
  },
  // 校验终点时间
  checkNodeTimeRange: {
    method: 'get',
    url: '/logistics/transportOrder/checkNodeTimeRange'
  },
  // 获取所有订单数量
  getMyOrderListCount: {
    method: 'post',
    url: '/logistics/transportOrder/driver/getMyOrderListCount'
  },
  // 确认提货
  confirmPickup: {
    method: 'post',
    url: '/logistics/transportOrder/driver/confirmPickup'
  },
  // 跑马灯
  marquee: {
    method: 'get',
    url: '/logistics/transportOrder/driver/marquee'
  },
  // 提货数量
  myOrderListCount: {
    method: 'post',
    url: '/logistics/transportOrder/driver/myOrderListCount'
  },
  // 校验码表里程
  queryMileageRepeat: {
    method: 'post',
    url: '/logistics/transportOrderNode/queryMileageRepeat'
  },
  // 接收人查询饲料签收数量
  queryFeedReceiptCount: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedReceiptCount',
    mask: true // 判断是否需要加载loading框
  },
  // 接收人查询饲料已签收列表
  queryFeedSignedList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedSignedList',
    mask: false // 判断是否需要加载loading框
  },
  // 接收人查询饲料待签收列表
  queryFeedUnsignedList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedUnsignedList',
    mask: false // 判断是否需要加载loading框
  },
  // 技术员查询饲料签收数量
  queryChargePersonCount: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryChargePersonCount',
    mask: true // 判断是否需要加载loading框
  },
  // 技术员查询饲料已签收列表
  queryChargePersonSignedList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryChargePersonSignedList',
    mask: false // 判断是否需要加载loading框
  },
  // 技术员查询饲料待签收列表
  queryChargePersonUnsignedList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryChargePersonUnsignedList',
    mask: false // 判断是否需要加载loading框
  },

  // 接收人查询运输单节点
  queryFeedSignNodeList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedSignNodeList',
    mask: false // 判断是否需要加载loading框
  },
  // 根据运输单查询签收码
  querySignCode: {
    method: 'get',
    url: '/logistics/transportOrderNode/querySignCode',
    mask: false // 判断是否需要加载loading框
  },
  // 校验签收码
  checkSignCode: {
    method: 'post',
    url: '/logistics/transportOrderNode/checkSignCode',
    mask: false // 判断是否需要加载loading框
  },
  // 校验签收码
  getPilotSiteListApi: {
    method: 'get',
    url: '/logistics/feedPreOrder/getPilotSiteList',
    mask: false // 判断是否需要加载loading框
  },
  // 查询复磅信息
  queryFeedReweight: {
    method: 'get',
    url: '/logistics/transportOrder/receiver/queryFeedReweight',
    mask: false // 判断是否需要加载loading框
  },
  // 收货人端-查看运输过程信息
  queryReceiverProcess: {
    method: 'get',
    url: '/logistics/transportOrder/receiver/process/query',
    mask: false // 判断是否需要加载loading框
  },
  // 收货人端-首页弹窗提醒收货
  queryDispachUnsignedLast: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryDispachUnsignedLast',
    mask: false // 判断是否需要加载loading框
  },
  // 特殊签收人-待签收列表
  queryFeedUnsignedSList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedUnsignedSList',
    mask: false // 判断是否需要加载loading框
  },
  // 特殊签收人-已签收列表
  queryFeedSignedSList: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedSignedSList',
    mask: false // 判断是否需要加载loading框
  },
  // 签收人-未签收数量
  queryFeedReceiptUnSignedCount: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryFeedReceiptUnSignedCount',
    mask: false // 判断是否需要加载loading框
  },
  // 技术员-未签收数量
  queryChargePersonUnSignedCount: {
    method: 'get',
    url: '/logistics/transportOrderNode/queryChargePersonUnSignedCount',
    mask: false // 判断是否需要加载loading框
  },


};

export default normalOrderAPI;



// WEBPACK FOOTER //
// ./src/api/normalOrder.js